import { API_URLS } from "../constants";
import { postRequest, putRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { FEATURE } = API_URLS;

//Getting Paginated Brand Locations
const getAllBrandsForFeatureFlags = (body) => {
  return postRequest(FEATURE.BRAND, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const updateFeatureFlagForBrand = (body) => {
  return putRequest(FEATURE.BASE, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const updateFeatureFlagForStore = (body) => {
  return putRequest(FEATURE.UPDATE_STORE_FEATURES, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const featureFlagsServices = {
  getAllBrandsForFeatureFlags,
  updateFeatureFlagForBrand,
  updateFeatureFlagForStore,
};
